import { atomWithReset } from 'jotai/utils';

import { INITIAL_SERIE_VIDEO_FILTERS, type SerieVideoFilters } from '../../types/serieVideoFilters';

/**
 * Átomo com o estado dos filtros (server-side) da listagem de Vídeos de uma Série.
 *
 * Deve ser consumido apenas via `useSerieVideoFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const serieVideoFiltersAtom = atomWithReset<SerieVideoFilters>(INITIAL_SERIE_VIDEO_FILTERS);
